<main class="main">

  <lib-taas-main-layout
    titleText="Enterprise Key Manager as a Service"
    [userDetails]="currentuser"
    [menuItemList]="taasMenuItemsKm"
    [activeRoute]="activeRoute"
    (navigateHomeRequest)="navigateHome()"
    (contextMenuEvent)="handleUserContextMenuEvent($event)"
    (routeUpdateRequest)="handleRouteUpdateRequest($event)"
    [class.test-service]="isTestService">

    <lib-taas-information-banner
      banner
      class="test-banner"
      [isVisible]="isTestService"
      bannerId="test-banner-content">
        <span i18n="Information Banner: Test Service Text for Banner">Test Service</span>
    </lib-taas-information-banner>

    <div class="app-content-wrapper">
      <router-outlet />
    </div>
  </lib-taas-main-layout>

  <lib-taas-hidden-version-info
    [appVersion]="appVersion"
    [commonUiLibVersion]="commonUiLibVersion"
    [backendVersion]="backendAppVersion" />
  <lib-taas-toastr />
</main>
